import React from 'react';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { SiteLink } from '../../../components';
import './highlighteditem.scss';

export function HighlightedItem(props) {
    const item = props.item;
    const cmsOption = props.cmsOption || {};

    const bgUrl = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl'));
    const title = cmsUtils.payload(item, 'CardTitle');
    const description = cmsUtils.payload(item, 'CardDescription');
    const weight = cmsUtils.payload(item, 'Weight');
    const price = cmsUtils.payload(item, 'Price');
    const linkUrl = cmsUtils.payload(item, 'LinkUrl');
    const bullet1 = cmsUtils.payload(item, 'Bullet1');
    const bullet2 = cmsUtils.payload(item, 'Bullet2');
    const bullet3 = cmsUtils.payload(item, 'Bullet3');
    const bullet4 = cmsUtils.payload(item, 'Bullet4');
    const buttonText = cmsUtils.payload(item, 'ButtonText') || 'Click here for more information and pricing';

    const bullets = [bullet1, bullet2, bullet3, bullet4].filter(b => b && b !== '');

    const cssClass = utils.classNames('cms_item', 'highlightedItem', item.cssClass || item.anchorName || '');

    return (
        <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
            <div className="highlightedItem__media">
                {bgUrl && (
                    <div className="highlightedItem__image" style={{ backgroundImage: utils.css.bgUrlStyle(bgUrl) }} />
                )}
                <div className="highlightedItem__overlay" aria-hidden="true" />
                {weight && <div className="highlightedItem__weight">{weight}KG</div>}
                {title && (
                    <h3 className="highlightedItem__title" dangerouslySetInnerHTML={{ __html: title }} />
                )}
            </div>
            <div className="highlightedItem__body">
                {price && (
                    <div className="highlightedItem__price">
                        <span className="highlightedItem__price-value">${price}</span>
                        <span className="highlightedItem__price-unit">per pack</span>
                    </div>
                )}
                {description && <div className="highlightedItem__desc" dangerouslySetInnerHTML={{ __html: description }} />}
                {bullets.length > 0 && (
                    <ul className="highlightedItem__bullets">
                        {bullets.map((b, i) => <li key={i}>{b}</li>)}
                    </ul>
                )}
                {linkUrl && (
                    <SiteLink to={linkUrl} className="highlightedItem__btn">
                        <span className="highlightedItem__btn-text">{buttonText}</span>
                        <svg className="highlightedItem__btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="5" y1="12" x2="19" y2="12" />
                            <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </SiteLink>
                )}
            </div>
        </div>
    );
}
